<div class="login-page">
    <mat-card class="form">
        <mat-card-content>
            <img alt="LM Credit Logo" height="35" ngSrc="/assets/images/lmcredit.png" style="margin: 0 15px 15px 15px"
                 width="81"/>
            <form (submit)="login()" [formGroup]="loginFormGroup">
                <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Email</mat-label>
                    <input formControlName="email" matInput type="email"/>
                </mat-form-field>

                <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Password</mat-label>
                    <input formControlName="password" matInput type="password"/>
                </mat-form-field>

                <button [disabled]="loginFormGroup.invalid" color="primary" mat-raised-button style="width: 100%"
                        type="submit">
                    Login
                </button>

                <div style="margin-top: 20px">
                    <a (click)="openMoreDetails()" href="javascript:void(0)">Can't log in?</a>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
    <div class="version">{{ appVersion }}</div>
</div>